<script setup>
  import videoIcon from '@/assets/images/bcst-video-icon.svg'
  import lockQuizzIcon from '@/assets/images/bcst-lock-quizz.svg'

  defineProps({
    // Title of the locked quiz (shown in the subtitle).
    quizTitle: { type: String, default: '' },
    // Required lesson the user must complete before taking the quiz.
    requiredLesson: { type: Object, default: null },
  })

  const emit = defineEmits(['reviewLesson'])

  function handleReviewLesson() {
    emit('reviewLesson')
  }
</script>

<template>
  <div class="bcst-quiz-locked-content">
    <img :src="lockQuizzIcon" alt="" class="bcst-quiz-locked-icon" />

    <p class="bcst-quiz-locked-title">
      <strong>Quiz locked</strong>
    </p>
    <p class="bcst-quiz-locked-subtitle">
      You need to complete the required lesson before taking
      <strong>{{ quizTitle || 'this quiz' }}</strong>.
    </p>

    <button
      v-if="requiredLesson"
      type="button"
      class="btn btn-outline-primary bcst-quiz-locked-btn"
      @click="handleReviewLesson">
      <img :src="videoIcon" alt="" class="bcst-quiz-locked-video-icon" />
      Review Lesson
    </button>
  </div>
</template>

<style scoped lang="scss">
  .bcst-quiz-locked-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 24px;
    border: 1px solid var(--bs-gray-300, #dee2e6);
    border-radius: 12px;
    background-color: var(--bs-white, #fff);
  }

  .bcst-quiz-locked-icon {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
  }

  .bcst-quiz-locked-title {
    color: var(--bs-gray-900, #212529);
    font-family: 'DM Sans', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 130%;
    letter-spacing: -0.4px;
    margin: 0 0 8px 0;
  }

  .bcst-quiz-locked-subtitle {
    color: var(--bs-gray-600, #6c757d);
    font-family: 'DM Sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: -0.32px;
    margin: 0 0 24px 0;
    max-width: 480px;
  }

  .bcst-quiz-locked-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 130%;
    letter-spacing: -0.32px;
  }

  .bcst-quiz-locked-video-icon {
    width: 20px;
    height: 20px;
    transition: filter 0.15s ease-in-out;
  }
  /* On hover the outline button fills with primary and the label turns white; recolor
     the SVG icon to white too (brightness(0) invert(1) forces any fill to white). */
  .bcst-quiz-locked-btn:hover .bcst-quiz-locked-video-icon,
  .bcst-quiz-locked-btn:focus .bcst-quiz-locked-video-icon {
    filter: brightness(0) invert(1);
  }
</style>
